<h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <mat-icon class="moveMatIcon">queue_play_next</mat-icon>
    <mat-label style="font-size: 16px; margin-left: 10px;">{{'general.registerPlayer' | transloco}}</mat-label>
    <div class="dlg-drag-handle" cdkDragHandle>
        @if ((signStudioProducts$ | async) != '1') {
            <app-video-link style="margin-right: 20px" videoLink="register_signplayer"></app-video-link>
        }
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
            <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
            <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
    </div>
    <br/>
</h1>

@if ((signStudioProducts$ | async) == '1') {
<mat-expansion-panel class="expand-panel">
    <mat-expansion-panel-header>
        <span style="margin-left: 20px;">How to Install SignPlayer</span>
    </mat-expansion-panel-header>
    <div class="header1">install SignPlayer on your Device
        <app-video-link style="display: inline-block;" videoLink="install_signplayer"></app-video-link>
    </div>
    <p class="installPlayer">On your <b style="font-weight: bold;">SignPlayer Device</b>, open the <span class="clickable-text" mat-icon-button (click)="copyInstallPlayerLink()">SignPlayer installation link</span>, and follow the instructions to complete the installation.</p>

    <div class="header1">or buy our mediaDroid+ SignPlayer
        <button matTooltip="{{'account.onSale' | transloco}}" mat-icon-button (click)="openOnSale()" class="hide-lt-md left-menu-button">
                    <mat-icon>sell</mat-icon>
                </button>
            </div>
            <p class="installPlayer">ready to use SignPlayer device with all the optimizations.</p>
            <br/>

</mat-expansion-panel>
}

<div mat-dialog-content>
    <div fxLayout="column" style="margin-left: 20px;">
        @if ((signStudioProducts$ | async) == '1') {
            <div class="header1">{{'general.registerPlayer' | transloco}}
                <app-video-link style="display: inline-block;" videoLink="register_signplayer"></app-video-link>
            </div>
        }
        <app-scene-selector #sceneSelector style="padding-left: 20px" [setMode]="'SCENE:PLAYER_ASSIGNABLE'" [mimeType]="mimeType" [previewMode]="false" [includeSelf]="true" [selectedSceneId]="sceneId" (changeSelectedScene)="selectScene($event)"></app-scene-selector>
        <mat-form-field class="input-field">
            <mat-label>{{ 'placeholder.playerName' | transloco }}</mat-label>
            <input matInput inputrestriction="basic1" type="text" class="form-control" [(ngModel)]="playerName" autocomplete="off"/>
            <a matSuffix aria-label="Clear" (click)="playerName=''">
                <mat-icon>close</mat-icon>
            </a>
        </mat-form-field>
        <div class="text1">registration code:</div>
        <app-station-reg-code #regCode class="regCode" (ready)="onCodeReady($event)"></app-station-reg-code>
    </div>
    <br/>
    <br/>
    <div fxFlex fxLayoutAlign="center center" fxLayoutGap="32px">
        <button (click)="onClose()" mat-raised-button>{{ 'general.cancel' | transloco }}</button>
        <button (click)="addPlayer()" mat-raised-button color="warn" [disabled]="!codeReady || !sceneId || !playerName" matTooltip="{{ 'general.registerPlayerCode' | transloco }}">
            @if (loading) {
                <app-loading [size]="'20px'" [style]="{'margin-top': '5px'}"></app-loading>
            } @else {
                <!--<mat-icon style="position: relative; left: -8px; top: 3px">queue_play_next</mat-icon>-->
                <span style="position: relative; top: 0px">{{ 'general.registerPlayer' | transloco }}</span>
            }
        </button>
    </div>
</div>
